import { createApp } from 'vue';

import Enum from '@interface/_index';
import RE from '@module/regexp';
import Check from '@module/check';
import Config from '@constant/config';
import FN from '@constant/function';
import RQ from '@server/request';
import Store from '@model/_index';
import Application from '@constant/application';
import VueApplication from './application.vue';
import i18n from './plujgins/i18n';
import { startFirstScreenDiagnostics, formatFirstScreenNotification } from '@module/firstScreenDiagnostics.js';
import { AxiosReportFirstScreen } from '@server/apiMonitor';
import { buildWebsiteDiagnosticIdentity } from '@template/page/_component/float/aidigitalhuman/websiteIdentity';

import '@constant/style';

const globalExpand: any = { // 拓展变量
    $ENV,
    $Lodash,
    $Moment,
    $Numeral,
    $MathJS,
    $Enum: Enum, // 公共枚举
    $RegExp: RE, // 正则表达式
    $Check: Check, // 校验
    $Config: Config, // 配置
    $FN: FN, // 函数库
    $RQ: RQ, // 请求库
    $Store: Store, // 存储
    $Application: Application // 应用
  },
  app = createApp(VueApplication);

Object.keys(globalExpand).forEach((v: string) => { // 全局挂载
  const config = {
    enumerable: false,
    writable: false,
    configurable: false,
    value: globalExpand[v]
  };
  
  Object.defineProperty(global, v, config);
  Object.defineProperty(app.config.globalProperties, v, config);
});

Application.Main = app;
startFirstScreenDiagnostics({
  enabled: $ENV.isProduction || new URLSearchParams(location.search).get('debug') === 'true',
  getContext: () => {
    return { env: 'galaxy', environment: $ENV.isFormal ? 'formal' : 'test', buildMode: $ENV.isProduction ? 'production' : 'development', ...buildWebsiteDiagnosticIdentity(Store.User()) };
  },
  report: (snapshot: any) => {
    // 全量入库，爬虫保留标记供统计筛选。
    snapshot.spider = /bot|spider|crawl|slurp/i.test(snapshot.userAgent || '');
    // 接口全量发送，飞书仅通知慢样本；两路异常各自静默，不互相阻断。
    return Promise.all([
      Promise.resolve().then(() => AxiosReportFirstScreen(snapshot)).catch(() => {}),
      Promise.resolve().then(() => snapshot.isSlow && RQ.PushWebHook(
        snapshot.current_user_name || '访客', formatFirstScreenNotification(snapshot)
      )).catch(() => {})
    ]);
  }
});
Application.Main
.directive('reveal', { // 滚动淡入：进入视口加 reveal-in，触发一次后停止观察
  mounted(el: HTMLElement): void {
    el.classList.add('reveal');

    if (typeof IntersectionObserver === 'undefined') {
      el.classList.add('reveal-in');
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    observer.observe(el);
  }
})
.use(i18n)
  .use(Application.Pinia)
  .use(Application.Router);

// Keep the loading screen until the first route's async component is available.
Application.Router.isReady().then(async () => {
  await (window as any).__siteStyleReady;
  if ((window as any).__siteStyleFailed) return;
  Application.Main.mount('body');
  document.documentElement.classList.add('site-app-mounted'); // 触发完整版淡入，弱化与加载页的硬切换
  (window as any).__stopSiteLoading?.();
  delete (window as any).__stopSiteLoading;
  performance.mark('galaxy-app-mounted');
});
